export default __webpack_public_path__ + "static/media/001-tile.3525076b.svg";